import tippy from 'tippy.js'

export class TooltipComponent {
  constructor(selector = "[data-tippy-content]", config = {arrow: true}){
    this.selector = selector;
    this.config = config;

    this.init()
  }

  init() {
    tippy(this.selector, this.config)
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/tooltip/tooltip.component.js